import { type FC, memo } from 'react';

export type CloudNatGatewayDetailData = {
  cloudProvider: string | null;
  gatewayId: string | null;
  vpcId: string | null;
  name: string | null;
  region: string | null;
  availabilityMode: string | null;
  connectivityType: string | null;
  sku: string | null;
  awsArn: string | null;
  availabilityZoneList: string[] | null;
  routeTableId: string | null;
  cloudRouterId: string | null;
  publicIpv4List: string[] | null;
  publicIpv6List: string[] | null;
};

interface Props {
  firstColumnClassName?: string;
  secondColumnClassName?: string;
  tableClassName?: string;
  tableData: CloudNatGatewayDetailData;
}

const BareCloudNatGatewayDetailContent: FC<Props> = (props) => {
  const cloudProvider = props.tableData.cloudProvider?.toLowerCase();
  return (
    <table className={props.tableClassName}>
      <tbody>
        <tr>
          <td className={props.firstColumnClassName}>Cloud provider</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.cloudProvider}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Name</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.name}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>NAT gateway ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.gatewayId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Cloud network ID</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.vpcId}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Public IPv4</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.publicIpv4List?.join(', ')}
          </td>
        </tr>
        <tr>
          <td className={props.firstColumnClassName}>Public IPv6</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.publicIpv6List?.join(', ')}
          </td>
        </tr>
        {(cloudProvider === 'gcp' || cloudProvider === 'azure') && (
          <tr>
            <td className={props.firstColumnClassName}>Region</td>
            <td className={props.secondColumnClassName}>
              {props.tableData.region}
            </td>
          </tr>
        )}
        {cloudProvider === 'azure' && (
          <tr>
            <td className={props.firstColumnClassName}>Availability zones</td>
            <td className={props.secondColumnClassName}>
              {props.tableData.availabilityZoneList?.join(', ')}
            </td>
          </tr>
        )}
        <tr>
          <td className={props.firstColumnClassName}>Connectivity type</td>
          <td className={props.secondColumnClassName}>
            {props.tableData.connectivityType}
          </td>
        </tr>
        {cloudProvider !== 'gcp' && (
          <tr>
            <td className={props.firstColumnClassName}>Availability mode</td>
            <td className={props.secondColumnClassName}>
              {props.tableData.availabilityMode}
            </td>
          </tr>
        )}
        {cloudProvider === 'azure' && (
          <tr>
            <td className={props.firstColumnClassName}>SKU</td>
            <td className={props.secondColumnClassName}>
              {props.tableData.sku}
            </td>
          </tr>
        )}
        {cloudProvider === 'gcp' && (
          <tr>
            <td className={props.firstColumnClassName}>Cloud router</td>
            <td className={props.secondColumnClassName}>
              {props.tableData.cloudRouterId}
            </td>
          </tr>
        )}
        {cloudProvider === 'aws' && (
          <>
            <tr>
              <td className={props.firstColumnClassName}>Availability zones</td>
              <td className={props.secondColumnClassName}>
                {props.tableData.availabilityZoneList?.join(', ')}
              </td>
            </tr>
            <tr>
              <td className={props.firstColumnClassName}>Route table</td>
              <td className={props.secondColumnClassName}>
                {props.tableData.routeTableId}
              </td>
            </tr>
            <tr>
              <td className={props.firstColumnClassName}>ARN</td>
              <td className={props.secondColumnClassName}>
                {props.tableData.awsArn}
              </td>
            </tr>
          </>
        )}
      </tbody>
    </table>
  );
};

export const CloudNatGatewayDetailContent = memo(
  BareCloudNatGatewayDetailContent,
);
